import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import axios from 'axios';

async function verifyToken(to, from, next) {
    let isLoggedIn = false;

    try {
        isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn')) === true;
    } catch (error) {
        isLoggedIn = false;
    }

    if (!isLoggedIn) {
        next('/login');
        return;
    }

    try {
        const response = await axios.get('/api/verify-token');
        
        if (response.data.valid) {
            next();
        } else {
            next('/login');
        }
    } catch (error) {
        next('/login');
    }
}

function cameFromInside(to, from, next) {
    const validPreviousRoutes = ['dashboard', 'update-chains', 'operations', 'management',
                                'faq', 'register-chain', 'update-stores', 'register-store',
                                'update-operators', 'register-operator', 'account',
                                'yearly-management', 'parameters'
    ];

    if (validPreviousRoutes.includes(from.name)) {
        next();
    } else {
        next();
    }
}

async function loadData() {
    try {
        const response = await fetch('./table.json');
        response.json().then(data => {
            localStorage.setItem('data', JSON.stringify(data));
        });
    } catch (error) {
        console.error(error);
    }

    
}

const routes = [
{
    path: '/',
    name: 'home',
    component: HomeView,
	meta: {
		title: 'Nossa Aliança'
	}
},
{
    path: '/sobre',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
	meta: {
		title: 'Nossa Aliança - Sobre Nós'
	}
},
{
    path: '/contato',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/ContactView.vue'),
	meta: {
		title: 'Nossa Aliança - Contato'
	}
},
{
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue'),
    meta: {
        title: 'Nossa Aliança - Login'
    }
},
{
    path: '/recuperar-senha',
    name: 'forgot-password',
    component: () => import(/* webpackChunkName: "forgot-password" */ '../views/ForgotPasswordView.vue'),
    meta: {
        title: 'Nossa Aliança - Recuperar Senha'
    }
},
{
    path: '/em-construcao',
    name: 'under-construction',
    component: () => import(/* webpackChunkName: "under-construction" */ '../views/UnderConstructionView.vue'),
    meta: {
        title: 'Nossa Aliança - Em Construção'
    }
},
{
    path: '/painel',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/DashboardView.vue'),
    meta: {
        title: 'Nossa Aliança - Painel'
    },
    beforeEnter: [verifyToken, loadData]
},
{
    path: '/cadastrar-rede',
    name: 'register-chain',
    component: () => import(/* webpackChunkName: "register-chain" */ '../views/RegisterChainView.vue'),
    meta: {
        title: 'Nossa Aliança - Cadastro de Rede'
    },
    beforeEnter: [verifyToken, cameFromInside]
},
{
    path: '/editar-rede',
    name: 'update-chains',
    component: () => import(/* webpackChunkName: "update-chains" */ '../views/UpdateChainsView.vue'),
    meta: {
        title: 'Nossa Aliança - Excluir/Editar Redes'
    },
    beforeEnter: [verifyToken, cameFromInside]
},
{
    path: '/cadastrar-loja',
    name: 'register-store',
    component: () => import(/* webpackChunkName: "register-store" */ '../views/RegisterStoreView.vue'),
    meta: {
        title: 'Nossa Aliança - Cadastro de Loja'
    },
    beforeEnter: [verifyToken, cameFromInside]
},
{
    path: '/editar-loja',
    name: 'update-stores',
    component: () => import(/* webpackChunkName: "update-stores" */ '../views/UpdateStoresView.vue'),
    meta: {
        title: 'Nossa Aliança - Excluir/Editar Lojas'
    },
    beforeEnter: [verifyToken, cameFromInside]
},
{
    path: '/cadastrar-operador',
    name: 'register-operator',
    component: () => import(/* webpackChunkName: "register-operator" */ '../views/RegisterOperatorView.vue'),
    meta: {
        title: 'Nossa Aliança - Cadastro de Operador'
    },
    beforeEnter: [verifyToken, cameFromInside]
},
{
    path: '/editar-operador',
    name: 'update-operators',
    component: () => import(/* webpackChunkName: "update-operators" */ '../views/UpdateOperatorsView.vue'),
    meta: {
        title: 'Nossa Aliança - Excluir/Editar Operadores'
    },
    beforeEnter: [verifyToken, cameFromInside]
}, 
{
    path: '/operacoes',
    name: 'operations',
    component: () => import(/* webpackChunkName: "operations" */ '../views/OperationsView.vue'),
    meta: {
        title: 'Nossa Aliança - Operações'
    },
    beforeEnter: [verifyToken, cameFromInside]
},
{
    path: '/controladoria-mensal',
    name: 'management',
    component: () => import(/* webpackChunkName: "management" */ '../views/ManagementView.vue'),
    meta: {
        title: 'Nossa Aliança - Controladoria'
    },
    beforeEnter: [verifyToken, cameFromInside]
},
{
    path: '/faq',
    name: 'faq',
    component: () => import(/* webpackChunkName: "faq" */ '../views/FAQView.vue'),
    meta: {
        title: 'Nossa Aliança - Perguntas Frequentes'
    },
    beforeEnter: [verifyToken, cameFromInside]
},
{
    path: '/conta',
    name: 'account',
    component: () => import(/* webpackChunkName: "account" */ '../views/AccountView.vue'),
    meta: {
        title: 'Nossa Aliança - Minha Conta'
    },
    beforeEnter: [verifyToken, cameFromInside]
},
{
    path: '/parametros',
    name: 'parameters',
    component: () => import(/* webpackChunkName: "parameters" */ '../views/ParametersView.vue'),
    meta: {
        title: 'Nossa Aliança - Parâmetros'
    },
    beforeEnter: [verifyToken, cameFromInside]
}, 
{
    path: '/tabela-operacao',
    name: 'insert-table',
    component: () => import(/* webpackChunkName: "insert-table" */ '../views/InsertTable.vue'),
    meta: {
        title: 'Nossa Aliança - Tabela de Operação'
    }
}, 
{
    path: '/controladoria-anual',
    name: 'yearly-management',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/YearlyManagementView.vue'),
    meta: {
        title: 'Nossa Aliança - Controladoria Anual'
    }
},
{
    path: '/controladoria',
    name: 'controladoria',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "teste" */ '../views/Dashteste.vue'),
	meta: {
		title: 'Nossa Aliança - Controladoria'
    },
    beforeEnter: [verifyToken, cameFromInside]
}
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
});

router.beforeEach((to, from,) => {
	document.title = to.meta?.title ?? 'Nossa Aliança';
});

export default router;
